<style lang="scss" scoped>
.install-notice {
	&:empty {
		display: none;
	}

	margin-bottom: 40px;
	text-align: center;

	&__clickable {
		cursor: pointer;
	}
}

.alert {
	margin-bottom: 0 !important;
	margin-top: -2px;
	position: sticky;
	z-index: 248;
}
</style>

<template lang="pug">
    .install-notice(v-if="!$apollo.loading")
        .install-notice__clickable.alert.alert-danger(v-if="shouldBook == true", @click="goToBookings")
            .container
                .row
                    .col
                        | It looks like Wonde is not connected to your school's MIS/SIS yet. Please
                        strong &nbsp;click here&nbsp;
                        | to finalise the setup.
        .alert.alert-success(v-if="appointment")
            .container
                .row
                    .col
                        | Your integration appointment is booked for&nbsp;
                        strong {{ appointment.start_at | nice_date }} ({{timezone}})
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import { first, filter } from "lodash";
import tracker from "@/utils/event-tracker";

export default {
	computed: {
		// The first appointment pending
		appointment() {
			if (this.User && this.User.Bookings) {
				return first(this.User.Bookings);
			}
		},
		timezone() {
			return Intl.DateTimeFormat().resolvedOptions().timeZone;
		},
		shouldBook() {
			if (!this.Companies) {
				return false;
			}

			if (this.Companies !== null && filter(this.Companies, { approved: true }).length > 0) {
				return true;
			}

			return false;
		}
	},
	apollo: {
		User: {
			query: gql`
				{
					User {
						id
						Bookings {
							id
							start_at
							end_at
						}
						School {
							id
							installed
						}
					}
				}
			`,
			update: r => r.User
		},
		Companies: {
			query: gql`
				{
					User {
						id
						Companies {
							id
							approved
						}
					}
				}
			`,
			update: r => r.User.Companies,
			skip() {
				if (this.User && this.User.School.installed == false && !this.appointment) {
					return false;
				}

				return true;
			}
		}
	},
	filters: {
		nice_date(value) {
			return moment(value).format("LLL");
		}
	},
	methods: {
		goToBookings() {
			this.$router.push({ name: "booking" });
			tracker("click-install-notice-booking");
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/admin/InstallNotice.vue